import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { DealerFeesModalLoader } from 'site-modules/shared/components/inventory/dealer-fees-modal/dealer-fees-modal-loader';

export const DealerFeesPriceDetailsAsync = lazyLoad({
  loader: /* istanbul ignore next */ () =>
    import('site-modules/shared/components/inventory/dealer-fees-price-details/dealer-fees-price-details'),
  componentName: 'DealerFeesPriceDetails',
  loading: DealerFeesModalLoader,
});
